import {
  BiddingDataTypes,
  ClientDataTypes,
  RobotDashboardSummaryTypes,
} from 'interfaces/robot_dashboard';
import Api from '../api';
import { dedupeBiddingsByPortalPrgCodOrgName } from '../utils/robot_dashboard_biddings';

export const fetchRobotDashboardSummary = async (
  setRobotSummary: React.Dispatch<React.SetStateAction<RobotDashboardSummaryTypes | null>>,
  setLoading: React.Dispatch<React.SetStateAction<boolean>>,
  setLoaded: React.Dispatch<React.SetStateAction<boolean>>,
  setError: React.Dispatch<React.SetStateAction<boolean>>,
) => {
  setLoading(true);
  const response = await Api.get('/robot_dashboard/client_store_summary.json');

  if (response.status === 200) {
    setRobotSummary(response.data);
    setLoaded(true);
    setLoading(false);
  } else {
    setError(true);
    setLoading(false);
  }
};

export const fetchRobotDashboardUsers = async (
  setUsersList: React.Dispatch<React.SetStateAction<ClientDataTypes[] | null>>,
  setLoading: React.Dispatch<React.SetStateAction<boolean>>,
  setLoaded: React.Dispatch<React.SetStateAction<boolean>>,
  setError: React.Dispatch<React.SetStateAction<boolean>>,
) => {
  setLoading(true);
  const response = await Api.get('/robot_dashboard/client_store.json');

  if (response.status === 200) {
    setUsersList(response.data.clients);
    setLoaded(true);
    setLoading(false);
  } else {
    setError(true);
    setLoading(false);
  }
};

export const fetchRobotDashboardBiddings = async (
  setBiddingsList: React.Dispatch<React.SetStateAction<BiddingDataTypes[] | null>>,
  setLoading: React.Dispatch<React.SetStateAction<boolean>>,
  setLoaded: React.Dispatch<React.SetStateAction<boolean>>,
  setError: React.Dispatch<React.SetStateAction<boolean>>,
  setProgress?: (percent: number) => void,
) => {
  setLoading(true);
  setProgress?.(0);
  const response = await Api.get('/robot_dashboard/bidding_store.json', {
    onDownloadProgress: (event: ProgressEvent) => {
      if (setProgress) {
        const percent = event.lengthComputable
          ? Math.round((event.loaded / event.total) * 100)
          : -1;
        setProgress(percent);
      }
    },
  });

  if (response.status === 200) {
    const biddings: BiddingDataTypes[] = response.data.biddings ?? [];
    setBiddingsList(dedupeBiddingsByPortalPrgCodOrgName(biddings));
    setLoaded(true);
    setLoading(false);
  } else {
    setError(true);
    setLoading(false);
  }
};

export const fetchRobotDashboardUserBiddings = async (
  id: string,
  setClientData: React.Dispatch<React.SetStateAction<ClientDataTypes | null>>,
  setBiddingsData: React.Dispatch<React.SetStateAction<BiddingDataTypes[]>>,
  setLoading: React.Dispatch<React.SetStateAction<boolean>>,
  setLoaded: React.Dispatch<React.SetStateAction<boolean>>,
  setError: React.Dispatch<React.SetStateAction<boolean>>,
) => {
  setLoading(true);

  const response = await Api.get(`robot_dashboard/client_store/${id}`);

  if (response.status === 200) {
    setClientData(response.data.client_data);
    const biddings: BiddingDataTypes[] = response.data.biddings_data ?? [];
    setBiddingsData(dedupeBiddingsByPortalPrgCodOrgName(biddings));
    setLoaded(true);
    setLoading(false);
  } else {
    setError(true);
    setLoading(false);
  }
};
